<template lang="pug">
  .horizontal-calendar
    span.left-arrow(v-if="showButtons" v-on:click="scrollLeft")
      v-icon.left-arrow__icon(name="chevron-left")

    .horizontal-calendar__date-list(ref="dateListElement")
      .horizontal-calendar__date-list-scroll
        .date-item(
          v-for="(day, index) in dateList"
          :key="index"
          @click="changeChoosedDay(day)"
          :class="{today: isToday(day), picked: isPickedDay(day), weekend: day.isWeekend, available: isDayAvailable(day)}"
        )
          //.first-day-mark(v-if="day.date == 1")
          .date-item__day {{ day.day }}
          .date-item__date {{ day.date }}
          .date-item__month {{ day.month }}

    span.right-arrow(v-if="showButtons" v-on:click="scrollRight")
      v-icon.left-arrow__icon(name="chevron-right")
</template>
<script>

import languages from "./languages"
import throttle from "lodash/throttle";

function isSameDay(first, second) {
  return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
}

export default {
  name: "vue-horizontal-calendar",
  props: {
    choosedDate: {
      type: [String, Date],
      required: false,
      default: () => {
        return new Date();
      },
    },
    availableDates: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    swipeSpace: {
      type: [String, Number],
      required: false,
      default: 7,
    },
    // 'left，center, right'
    choosedDatePos: {
      type: String,
      required: false,
      default: "center",
    },
    // 最小日期，可接收格式如 ‘2019/12/01’ 或 ‘2019-12-01’ 或 标准UTC格式时间
    minDate: {
      type: [String, Date],
      required: false,
      default: "",
    },
    // 最大日期，可接收格式如 ‘2019/12/01’ 或 ‘2019-12-01’ 或 标准UTC格式时间
    maxDate: {
      type: [String, Date],
      required: false,
      default: "",
    },
    // Language
    lang: {
      type: String,
      required: false,
      default: "ru",
    },
    showButtons: {
      required: false,
      default: false
    },
    tileWidth: {
      required: true,
      default: 66,
    }
  },
  data() {
    return {
      // 每一个日期对象的数据结构如下
      // {
      //   dateFormat: "2019/07/20",
      //   year: "2019",
      //   month: "07",
      //   date: "20",
      //   timestamp: 1564046915797,
      //   day: "六"
      // }

      firstDay: {}, //当前显示的第一个日期
      visibleDay: "", // 计算屏幕可放置的日期方块的数量
      changeCount: parseInt(this.swipeSpace), //点击左右箭头，增量的日期数量，默认为7天
      choosedDay: {}, // 当前选中的日期
      dateList: [{
        timestamp: Date.now()
      }], // 当前的日期列表
      today: {}, // 今天

      domWidth: 0, // 日历组件宽度

      swipeLeftMore: true, // 是否还能左滑
      swipeRightMore: true, // 是否还能右滑

      throttledScrollHandler: null,
      throttledResizeHandler: null,
      WheelHandler: null,
    };
  },
  mounted() {
    this.init();
    this.initScrollHandler();
    this.initResizeHandler();
    this.initWheelScroll();
    this.$nextTick(() => {
      this.$refs.dateListElement.querySelector('.today')?.scrollIntoView({
        block: "end",
        inline: "center",
        behavior: "auto"
      });
    });
    this.$emit("firstDayChange", this.firstDay);
    this.$emit("input", this.choosedDay);
  },
  beforeDestroy() {
    this.destroyScrollHandler();
    this.destroyResizeHandler();
    this.destroyWheelScroll();
  },
  methods: {
    init() {
      this.domWidth = this.$el.scrollWidth;
      let n = (this.domWidth - this.tileWidth) / this.tileWidth;
      if (n % 1 !== 0) {
        n = parseInt(n) + 1;
      }
      this.visibleDay = n;

      if (this.changeCount > this.visibleDay) {
        this.changeCount = this.visibleDay;
      }

      this.today = this.formatOneDay(new Date());
      this.choosedDay = this.formatOneDay(this.choosedDate);

      // 第一天
      let firstDay = this.formatOneDay(this.choosedDate);
      if (this.choosedDatePos === "center") {
        let ts1 =
            firstDay.timestamp -
            parseInt(this.visibleDay / 2) * 1000 * 60 * 60 * 24;
        this.firstDay = this.formatOneDay(ts1);
      } else if (this.choosedDatePos === "right") {
        let ts2 =
            firstDay.timestamp -
            parseInt(this.visibleDay - 1) * 1000 * 60 * 60 * 24;
        this.firstDay = this.formatOneDay(ts2);
      } else {
        this.firstDay = firstDay;
      }
      this.createList();
    },
    /**
     * Создание списка дат для отображения в календаре
     * @param {number} additionalDays Добавочные дни, которые обеспечивают рендер недостающих дат, и автоматический скролл к выбираемой по умолчанию дате
     */
    createList(additionalDays = 0) {
      let list = [];
      let firstDayTime = this.firstDay.timestamp;
      const daysAmount = this.visibleDay * 3 + additionalDays;

      for (let i = 0; i < daysAmount + 7; i++) {
        let timestamp = firstDayTime + 1000 * 60 * 60 * 24 * i;
        let info = this.formatOneDay(new Date(timestamp));
        list.push(info);
      }
      this.dateList = list;
      this.swipeLeftMore = true;
      this.swipeRightMore = true;
    },
    changeChoosedDay(day) {
      this.choosedDay = day;
      this.$emit("input", day);
    },
    //dateFlip(type) {
    // let beforeChangeLen = this.dateList.length;
    /**
     * 计算当前显示的第一天 的变化
     * 因为当前function执行中存在异步过程，且动画执行也需要时间，因此延时执行
     */
    // setTimeout(() => {
    // 数据变更后的部分数据
    // let afterChangeX = this.translateX;
    // let afterChangeLen = this.dateList.length;
    // // 如果x前后都相等，则计算当前日期列表的长度变化
    // if (beforeChangeX === afterChangeX) {
    //   let changeDay = afterChangeLen - beforeChangeLen;
    //   // 如果点击之后日历没变化(当最大或最小值存在的时候，就可能出现此种情况)，则不往下执行
    //   if (changeDay === 0) return;
    //   this.firstDay = this.formatOneDay(
    //       this.formatDateTime(
    //           this.firstDay.timestamp - 3600 * 1000 * 24 * changeDay
    //       )
    //   );
    // } else {
    //   let changeDay = (afterChangeX - beforeChangeX) / this.tileWidth;
    //   this.firstDay = this.formatOneDay(
    //       this.formatDateTime(
    //           this.firstDay.timestamp - 3600 * 1000 * 24 * changeDay
    //       )
    //   );
    // }
    // this.$emit("firstDayChange", this.firstDay);
    // }, 300);
    // this.$emit("swipeClick", type === 1 ? "right" : "left");
    //},
    formatOneDay(day) {
      const date = new Date(day);
      const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const timestamp = startOfDay.getTime();
      const epochTimestamp = timestamp / 1000;
      const dayNumber = date.getDay();

      return {
        year: date.getFullYear(),
        month: this.getMonthName(new Date(startOfDay)),
        date: date.getDate(),
        timestamp,
        epochTimestamp,
        dayNumber,
        day: this.getDayName(dayNumber),
        isWeekend: dayNumber === 0 || dayNumber === 6,
      };
    },
    /**
     * Возвращает краткое название дня недели
     * @param day
     * @returns String
     */
    getDayName(day) {
      return languages[this.lang][day];
    },
    /**
     * Возвращает полное название месяца
     * @param date
     * @returns {string}
     */
    getMonthName(date) {
      return date.toLocaleString(this.lang, {month: 'long'});
    },
    formatDateTime(timestamp) {
      if (!timestamp) return "";
      timestamp = parseInt(timestamp); // 防止传入字符串类型
      let fdt = new Date(timestamp);
      let arr = [fdt.getMonth() + 1, fdt.getDate()];
      for (let key in arr) {
        if (arr[key] < 10) {
          arr[key] = "0" + arr[key];
        }
      }
      arr.unshift(fdt.getFullYear());
      return arr[0] + "/" + arr[1] + "/" + arr[2];
    },
    isToday(day) {
      return day.timestamp === this.today.timestamp;
    },
    isPickedDay(day) {
      const dayDate = new Date(day.timestamp);
      return isSameDay(dayDate, new Date(this.choosedDay.timestamp))
    },
    isDayAvailable(day) {
      const dayDate = new Date(day.timestamp);
      return this.availableDates.some(date => isSameDay(dayDate, new Date(date * 1000)));
    },
    scrollLeft() {
      this.$refs.dateListElement.scrollTo({
        left: this.$refs.dateListElement.scrollLeft - this.tileWidth * this.changeCount,
        behavior: "smooth",
      });
    },
    scrollRight() {
      this.$refs.dateListElement.scrollTo({
        left: this.$refs.dateListElement.scrollLeft + this.tileWidth * this.changeCount,
        behavior: "smooth",
      });
    },
    addElementsLeft() {
      // else if (!this.swipeLeftMore) {
      //   // this.translateX = 0;
      //   // this.$emit("swipeToEnd", "left");
      // }

      let fdt = this.dateList[0].timestamp;
      let list = [];
      let i;
      for (i = 0; i < this.changeCount; i++) {
        let timestamp = fdt - 1000 * 60 * 60 * 24 * (i + 1);
        let info = this.formatOneDay(new Date(timestamp));
        // 如果存在最小日期限制,且当前这个日期小于最小限制，则停止循环
        if (this.minDate && info.timestamp < this.minDateTimestamp) {
          this.swipeLeftMore = false;
          break;
        }
        list.unshift(info);
      }
      // 消除过渡效果，插入新日期，变更x轴位置，以抵消插入数据带来的位置变化
      // this.transitionDuration = "0ms";
      this.dateList.unshift(...list);
      // i 表示新增的日期数量； 因为循环可能会被最大最小值中断，所以 i 相对于 changeCount 更准确
      // this.translateX = this.translateX - this.tileWidth * i;


      // 异步重置过渡效果，位移div
      // setTimeout(() => {
      // this.transitionDuration = "300ms";
      // this.translateX = this.translateX + this.tileWidth * i;
      this.$refs.dateListElement.scrollLeft = this.tileWidth * this.changeCount;
      // }, 100);
    },
    addElementsRight() {
      // if (!this.swipeRightMore) {
      //   // this.translateX = (this.dateList.length - this.visibleDay) * -this.tileWidth;
      //   this.$emit("swipeToEnd", "right");
      //   return;
      // }
      let fdt = this.dateList[this.dateList.length - 1].timestamp;
      let i;
      for (i = 0; i < this.changeCount; i++) {

        let timestamp = fdt + 1000 * 60 * 60 * 24 * (i + 1);
        let info = this.formatOneDay(new Date(timestamp));

        if (this.maxDate && info.timestamp > this.maxDateTimestamp) {
          this.swipeRightMore = false;
          break;
        } else {
          this.dateList.push(info);
        }
      }
      // if (i < this.changeCount) {
      // this.translateX = (this.dateList.length - this.visibleDay) * -this.tileWidth;
      // } else {
      // this.translateX = this.translateX - this.tileWidth * i;
      // }
    },
    /**
     * Обработчик скролла
     * При достижении краев элемента
     * инициирует добавляение элементов
     */
    initScrollHandler() {
      const scrollHandler = () => {
        const {scrollWidth, offsetWidth, scrollLeft} = this.$refs.dateListElement;
        const isHasSpaceLeft = scrollLeft > this.tileWidth * this.swipeSpace * 2;
        const isHasSpaceRight = scrollWidth - offsetWidth - scrollLeft > this.tileWidth * this.swipeSpace * 2;

        if (!isHasSpaceLeft && this.swipeLeftMore === false) {
          this.addElementsLeft();
        }

        if (!isHasSpaceRight) {
          this.addElementsRight();
        }
      }
      this.throttledScrollHandler = throttle(scrollHandler, 300);
      this.$refs.dateListElement.addEventListener('scroll', this.throttledScrollHandler);
    },
    destroyScrollHandler() {
      this.$refs.dateListElement.removeEventListener('scroll', this.throttledScrollHandler);
    },
    /**
     * Обработчик изменения размеров окна
     * При увеличении размеров окна
     * инициирует добавление элементов справа
     */
    initResizeHandler() {
      const resizeHandler = () => {
        const {offsetWidth, scrollWidth} = this.$refs.dateListElement;
        if (offsetWidth && scrollWidth === offsetWidth) {
          const itemsGap = parseInt((offsetWidth - this.dateList.length * this.tileWidth) / this.tileWidth);
          const callAmount = parseInt(itemsGap / this.changeCount) + 1;
          for (let i = callAmount; i >= 0; i--) {
            this.addElementsRight();
          }
        }
      };
      this.throttledResizeHandler = throttle(resizeHandler, 300);
      window.addEventListener('resize', this.throttledResizeHandler);
    },
    destroyResizeHandler() {
      window.removeEventListener('resize', this.throttledResizeHandler);
    },
    /**
     * Обработчик скролла колесом
     * Добавляет возможность скроллить
     * колесом мыши
     */
    initWheelScroll() {
      const throttledScrollLeft = throttle(this.scrollLeft, 300, {trailing: false});
      const throttledScrollRight = throttle(this.scrollRight, 300, {trailing: false});
      this.wheelHandler = function (e) {
        e.preventDefault();
        if (e.deltaY > 0) {
          throttledScrollRight();
        } else {
          throttledScrollLeft();
        }
      };
      this.$refs.dateListElement.addEventListener('wheel', this.wheelHandler);
    },
    destroyWheelScroll() {
      this.$refs.dateListElement.removeEventListener('wheel', this.wheelHandler);
    }
  },
  computed: {
    minDateTimestamp() {
      if (this.minDate) {
        let day = this.formatOneDay(this.minDate);
        return day.timestamp;
      }
      return null;
    },
    maxDateTimestamp() {
      if (this.maxDate) {
        let day = this.formatOneDay(this.maxDate);
        return day.timestamp;
      }
      return null;
    }
    ,
  },
  watch: {
    lang(code) {
      this.lang = code;
      this.createList();
    },
    choosedDate(newChoosedDate) {
      const lastAvailableDateTimestamp = [...this.dateList].pop().timestamp;
      const newChoosedDateTimestamp = new Date(newChoosedDate).getTime();
      const additionalDays = Math.ceil((newChoosedDateTimestamp - lastAvailableDateTimestamp) / 86400000) + 7;

      if (additionalDays > 0) {
        this.createList(additionalDays);
      }

      setTimeout(() => {
        document.querySelector('.date-item.picked').scrollIntoView({behavior: 'smooth', inline: 'center'});
      }, 500);

      this.choosedDay = this.formatOneDay(newChoosedDate);
      this.$emit("input", this.choosedDay);
    },
  },
};
</script>

